// extracted by mini-css-extract-plugin
module.exports = {"reviewsWrapper":"az_Nxc","bigRating":"az_Oxc","ratingStar":"az_Pxc","ratingText":"az_Qxc"};